<script>

	import {onMount} from "svelte";
	import {LmsUtils} from "../utils/LmsUtils";
	import {External, M} from "../../external";

	export let circle, memberDetails;

	let showingAllCircles = false;
	let circleDetails = [];
	let completedPages = {};

	let toDateString = timeStr => {
		return timeStr ? External.Tools.dateToString(new Date(timeStr), false, false, true) : '';
	}

	let getEnrolledOn = (circle) => {
		let access = memberDetails.access.find(access => access.itemId === circle.id);
		return access?.enrolled ? access.enrolledOn : '';
	}

	let getCompletedOn = (page) => {
		let access = memberDetails.access.find(access => access.itemId === page.id);
		return access?.completed ? access.completedOn : '';
	}

  const filterCircles = (accesses, circleId) => {
    const access = accesses.find(access => access.itemId === circleId);
    return !['BANNED', 'ACCESS_REQUESTED'].includes(access.status);
  }

	onMount(() => {
		showingAllCircles = !circle.id;
		let circlesToUse;
		if (showingAllCircles) {
			circlesToUse = memberDetails.circles.filter(details => filterCircles(memberDetails.access, details.circle.id));
		} else {
			circlesToUse = memberDetails.circles.filter(details => details.circle.id === circle.id && filterCircles(memberDetails.access, details.circle.id));
		}

		circleDetails = circlesToUse.map(details => {
			let ordered = LmsUtils.getPagesAndGroupsInOrder(details);
			let orderedWithTrackingEnabled = [];
			let trackedPagesCount = 0;
			let completedPagesCount = 0;
			let latestCompletedPage = 0;
			for (let idx = 0; idx < ordered.length; idx++) {
				let item = ordered[idx];
				if (item.pageGroup) {
					let completedGroupPagesCount = 0;
					let trackedPages = item.pages.filter(page => page.settings?.trackContentCompletion);
					trackedPagesCount += trackedPages.length;

					trackedPages.forEach((page) => {
						let completedOn = getCompletedOn(page);
						if (completedOn) {
							latestCompletedPage = Math.max(latestCompletedPage, completedOn);
							completedPages[page.id] = toDateString(completedOn);
							++completedGroupPagesCount;
							++completedPagesCount;
						}
					});

					if (trackedPages.length > 0) {
						orderedWithTrackingEnabled.push({
							group: item.pageGroup,
							pages: trackedPages,
							completedPagesCount: completedGroupPagesCount
						});
					}
				} else if (item.settings?.trackContentCompletion) {
					++trackedPagesCount;
					orderedWithTrackingEnabled.push({
						page: item
					});
					let completedOn = getCompletedOn(item);
					if (completedOn) {
						latestCompletedPage = Math.max(latestCompletedPage, completedOn);
						completedPages[item.id] = toDateString(completedOn);
						++completedPagesCount;
					}
				}
			}

			return {
				circle: details.circle,
				ordered: orderedWithTrackingEnabled,
				trackedPagesCount: trackedPagesCount,
				completedPagesCount: completedPagesCount,
				circleCompletedOn: trackedPagesCount === completedPagesCount ? toDateString(latestCompletedPage) : '-',
				expanded: false
			};
		});

		if (circleDetails.length) {
			circleDetails[0].expanded = true;
		}
	})
</script>


<div class="scrollable-table orders-scrollable-tablee scrollable-table-design strnger-border multi-level-table mb-25">
	<table style="margin-top: 0px;">
		<thead>
		<tr class="flex flex-row align-center" style="padding-bottom: 0px;">
			<th class="checkbox-table"></th>
			<th class="flex-none mw-240" style="padding-left: 20px;"><a>{M.NAME}</a></th>
			<th class="flex-none mw-100"><a>{M.PROGRESS}</a></th>
			<th class="flex-none mw-120"><a>{M.STATUS}</a></th>
			<th class="flex-none mw-120"><a>{M.ENROLLMENT_DATE}</a></th>
			<th class="flex-none mw-120"><a>{M.COMPLETION_DATE}</a></th>
		</tr>
		</thead>
		<tbody style="height: auto;">
		{#each circleDetails as detail}
			{#if detail.trackedPagesCount === 0}
				<tr class="flex flex-row align-center mb-0 mt-10">
					<td class="checkbox-table">&nbsp;</td>
					<td class="flex-none mw-240" style="padding-left: 20px;">{detail.circle.name}</td>
					<td class="flex-none mw-100">&nbsp;</td>
					<td class="flex-none mw-120"><span class="pay-status not-paid">{M.NO_TRACKING}</span></td>
					<td class="flex-none mw-140">&nbsp;</td>
					<td class="flex-none mw-140">&nbsp;</td>
				</tr>
			{:else}
				<tr class="flex flex-row align-center mb-0 mt-10">
					<td class="checkbox-table">
						<a class="table-expand-btn f-left" on:click={() => detail.expanded = !detail.expanded}>
							<svg class="f-left" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
								<path d="M0 0h24v24H0V0z" fill="none"/>
								{#if detail.expanded}
									<path
										d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
								{:else}
									<path
										d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
								{/if}
							</svg>
						</a>
					</td>
					<td class="flex-none mw-240" style="padding-left: 20px;">{detail.circle.name}</td>
					<td class="flex-none mw-100"><a>{detail.completedPagesCount}/{detail.trackedPagesCount}</a></td>
					<td class="flex-none mw-120">
						{#if detail.completedPagesCount === detail.trackedPagesCount}
							<span class="pay-status paid">{M.CIRCLE_COMPLETED}</span>
						{:else}
							<span class="pay-status not-paid">{M.NOT_COMPLETE}</span>
						{/if}
					</td>
					<td class="flex-none mw-140">{toDateString(getEnrolledOn(detail.circle))}</td>
					<td class="flex-none mw-140">{detail.circleCompletedOn}</td>
				</tr>
				{#if detail.expanded}
					<tr class="inner-table-wrapper">
						<td>
							<table class="inner-table" style="margin-top: 0px;">
								<thead>
								<tr class="flex flex-row align-center" style="padding-bottom: 0px;">
									<th class="flex-none mw-240" style="padding-left: 20px;"><a>{M.PAGE_NAME}</a></th>
									<th class="flex-none mw-120"><a>{M.STATUS}</a></th>
									<th class="flex-none"><a>{M.COMPLETION_DATE}</a></th>
								</tr>
								</thead>
								<tbody style="height: auto;">
								{#each detail.ordered as item}
									{#if item.group}
										<tr class="flex flex-row align-center inner-table-row">
											<td class="flex-none mw-300" style="padding-left: 20px;">
												<b class="inner-circle-separator">{item.group.name} ({item.completedPagesCount}/{item.pages.length}) ↓</b>
											</td>
										</tr>
										{#each item.pages as page}
											<tr class="flex flex-row align-center inner-table-row">
												<td class="flex-none mw-240" style="padding-left: 20px;">{page.name}</td>
												{#if completedPages[page.id]}
													<td class="flex-none mw-120">
														<span class="pay-status paid">{M.COMPLETED}</span>
													</td>
													<td class="flex-none">{completedPages[page.id]}</td>
												{:else}
													<td class="flex-none mw-120">
														<span class="pay-status not-paid">{M.NOT_COMPLETE}</span>
													</td>
													<td class="flex-none">-</td>
												{/if}
											</tr>
										{/each}
									{:else}
										<tr class="flex flex-row align-center inner-table-row">
											<td class="flex-none mw-240" style="padding-left: 20px;">{item.page.name}</td>
											{#if completedPages[item.page.id]}
												<td class="flex-none mw-120">
													<span class="pay-status paid">{M.COMPLETED}</span>
												</td>
												<td class="flex-none">{completedPages[item.page.id]}</td>
											{:else}
												<td class="flex-none mw-120">
													<span class="pay-status not-paid">{M.NOT_COMPLETE}</span>
												</td>
												<td class="flex-none">-</td>
											{/if}
										</tr>
									{/if}
								{/each}
								</tbody>
							</table>
						</td>
					</tr>
				{/if}
			{/if}
		{/each}
		</tbody>
	</table>
</div>
